export const ABLY_SESSION_STAFF_SUFFIX = '-staff' as const;

export type LiveChatMode = 'PUBLIC' | 'PRIVATE' | 'DISABLED';

export function ablyPrivateChatChannelName(baseSessionChannelName: string): string | null {
  const base = baseSessionChannelName.trim();
  if (!base) return null;
  return `${base}${ABLY_SESSION_STAFF_SUFFIX}`;
}
